'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const React = require('react');
const reactAria = require('react-aria');
const SelectBase_SelectBase = require('../SelectBase/SelectBase.cjs.js');
const ErrorMessage_ErrorMessage = require('../ErrorMessage/ErrorMessage.cjs.js');
const Select_SelectGroup = require('./SelectGroup.cjs.js');
const Select_SelectItem = require('./SelectItem.cjs.js');
const designSystem = require('@zapier/design-system');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const Select = (_a) => {
  var { children, errorMessage, helpText, isInvalid = false, isLabelHidden = false, label } = _a, props = tslib_es6.__rest(_a, ["children", "errorMessage", "helpText", "isInvalid", "isLabelHidden", "label"]);
  const isSSR = reactAria.useIsSSR();
  if (isSSR) {
    return null;
  }
  return React__default.default.createElement(
    SelectBase_SelectBase.SelectBase,
    Object.assign({}, props, { isInvalid }),
    isLabelHidden ? React__default.default.createElement(
      designSystem.VisuallyHidden,
      null,
      React__default.default.createElement(SelectBase_SelectBase.SelectBase.Label, null, label)
    ) : React__default.default.createElement(
      SelectBase_SelectBase.SelectBase.Label,
      null,
      isInvalid && React__default.default.createElement(designSystem.Icon, { color: "StatusErrorStronger", isBlock: true, name: "formXCircle", size: 18 }),
      label
    ),
    React__default.default.createElement(
      SelectBase_SelectBase.SelectBase.TriggerButton,
      null,
      React__default.default.createElement(SelectBase_SelectBase.SelectBase.Value, null),
      React__default.default.createElement(designSystem.Icon, { name: "arrowDropdown", color: "TextWeaker", size: props.size === "compact" ? 20 : 24 })
    ),
    isInvalid && errorMessage ? React__default.default.createElement(ErrorMessage_ErrorMessage.ErrorMessage, { isCompact: props.size === "compact" }, errorMessage) : helpText && React__default.default.createElement(SelectBase_SelectBase.SelectBase.Description, null, helpText),
    React__default.default.createElement(
      SelectBase_SelectBase.SelectBase.Popover,
      null,
      React__default.default.createElement(SelectBase_SelectBase.SelectBase.ListBox, null, children)
    )
  );
};
Select.Item = Select_SelectItem.SelectItem;
Select.Group = Select_SelectGroup.SelectGroup;

exports.Select = Select;
//# sourceMappingURL=Select.cjs.js.map
